'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackSendMessage = undefined;

var _trackInteraction = require('../../usage-tracking/actions/trackInteraction');

var trackSendMessage = exports.trackSendMessage = function trackSendMessage(_ref) {
  var threadId = _ref.threadId;
  return function (dispatch) {
    var eventProps = {};

    if (typeof threadId === 'number') {
      eventProps.threadId = threadId;
    }

    dispatch((0, _trackInteraction.trackInteraction)('send-message', eventProps));
  };
};


//////////////////
// WEBPACK FOOTER
// ./js/pubsub/actions/trackSendMessage.js
// module id = 527
// module chunks = 2 3